import { DownloadIcon } from '@navi/web-ui/lib/icons';
import { IUserDocument } from '../constants/constants';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { AGENT_LOGOUT_CLICK } from '@cp/src/service/clickStream.constant';
import { downloadDocumentFromS3WithoughtPreview } from '@cp/src/utils/DocumentDownloadFromS3';

const UserDocument = (props: IUserDocument) => {
  const { document, isLastDocument } = props;

  const handleDownloadDraClick = () => {
    addClickstreamEvent(AGENT_LOGOUT_CLICK.LH_DOCUMENT_DOWNLOAD_CLICKED, {
      documentType: document?.documentType,
      documentName: document?.documentName
    });
    downloadDocumentFromS3WithoughtPreview(
      document?.uri,
      document?.documentName,
      `Cannot Download the ${document?.documentName}`
    );
  };

  return (
    <div
      role="button"
      className={`flex justify-between cursor-pointer p-2 border-solid border-0 border-[var(--navi-color-gray-border)] ${
        !isLastDocument ? 'border-b' : null
      }  `}
      onClick={handleDownloadDraClick}
    >
      <div className="flex flex-row justify-between gap-1">
        <DownloadIcon width={20} height={20} color="var(--blue-base)" />
        <div className="flex items-center text-grayscale-content-2 text-xs font-medium leading-5">
          {`Download ${document?.documentName}`}
        </div>
      </div>
    </div>
  );
};

export default UserDocument;
